import { PrivacyPolicy } from "src/store/type";

export const defaultPrivacyPolicy: PrivacyPolicy = {
    versionNumber: null,
    policyContent: null,
    policyUrl: null,
    policyDocTypeId: null,
};

export enum SingupType {
    Quick = 1,
    PinCode,
    User,
    OnTimeLogin,
}

export enum RefreshTokenStatus {
    Init = 1,
    Ok,
    Invalid,
}

export interface IAccount {
    accountCode: number; // eg 5 (Maya Tour)
    accountName: string; // eg Maya Tour
    accountGuid?: string;
    contactUUID: string; // ? Id of contact signed in to Studio in selected...
    // ? ... account's DB?
    dbUrl: string; // Maya tours Db url
    proxyUrl?: string; // ?
    proxyToken: IProxToken;
}

export interface IProxToken {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
    expiresAt?: number;
}

export interface ResPrivacyPolicyApproval {
    response: PrivacyPolicyApprovalEnum;
    message: string;
}

export enum PrivacyPolicyApprovalEnum {
    SUCCESS = '0',
    ALREADY_APPROVED = '1',
    MISSING_DETAILS = '2',
    SQL_ERROR = '99',
}

export interface ResPrivacyPolicyApprovalFromMobile {
    response: PrivacyPolicyApprovalEnum;
    verifyCode: string;
    message: string;
}

export enum ResPinCodeSignup {
    SUCCESS = '0',
    MESS_TOKEN = '1',
    WRONG_PIN_CODE = '2',
    EXPIRED_TOKEN = '3',
    INVALID_TOKEN = '4',
    PRIVACY_POLICY_NOT_APPROVED = '5',
    WRONG_PIN_CODE_TO_MANY_TIMES = '9',
    FAILED_TO_FIND_PHONE = 40,
    TOO_MANY_ATTEMPTS_LOCKED = '52',
    SQL_ERROR = '99',
}
export enum ResPinCodeLogin {
    SUCCESS = '0',
    INVALID_INPUTS = '1',
    INVALID_TOKEN = '2',
    PRIVACY_POLICY_NOT_APPROVED = '5',
    WRONG_PIN_CODE = '3',
    TOO_MANY_ATTEMPTS_LOCKED = '52',
}

export enum ResUserLogin {
    SUCCESS = '0',
    MISSING_DETAILES = '1',
    WRONG_USER_OR_CODE = '2',
}
